export var Outcome;
(function (Outcome) {
  Outcome["BeforeSend"] = "before_send";
  Outcome["EventProcessor"] = "event_processor";
  Outcome["NetworkError"] = "network_error";
  Outcome["QueueOverflow"] = "queue_overflow";
  Outcome["RateLimitBackoff"] = "ratelimit_backoff";
  Outcome["SampleRate"] = "sample_rate";
})(Outcome || (Outcome = {}));